<script setup lang="ts">
import {computed} from 'vue';

const props = defineProps({
    slide: {
        type: Object,
        required: true,
    },
    isActive: {
        type: Boolean,
        default: false,
    },
});

defineEmits([
    'mouseenter',
    'mouseleave',
]);

const cardClasses = computed(() => ({
    'service-card--active': props.isActive,
}));
</script>

<template>
    <div :class="cardClasses" class="service-card">
        <div class="service-card__top">
            <h3 class="service-card__title">{{ slide.title }}</h3>

            <span class="service-card__price">
                {{ slide.price }}
            </span>
        </div>


        <div>
            <svg v-if="slide.ico" class="service-card__ico">
                <use :href="`#${slide.ico}`" />
            </svg>

            <p v-if="slide.description" class="service-card__description">
                {{ slide.description }}
            </p>
        </div>
    </div>
</template>

<style scoped lang="scss">
@import "styles/service-card";
</style>
